import { render, staticRenderFns } from "./CustomLoading.vue?vue&type=template&id=2c25846d&"
import script from "./CustomLoading.vue?vue&type=script&lang=js&"
export * from "./CustomLoading.vue?vue&type=script&lang=js&"
import style0 from "./CustomLoading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports